import { render, staticRenderFns } from "./BookeeProduct.vue?vue&type=template&id=5d00c4cc&"
import script from "./BookeeProduct.vue?vue&type=script&lang=js&"
export * from "./BookeeProduct.vue?vue&type=script&lang=js&"
import style0 from "./BookeeProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports